import React, { useEffect, useState } from 'react';
import cx from 'classnames';
import { useMedia } from 'react-use-media';
import styled from '@emotion/styled';
import { RichText } from '@vimily/bonjoro-ui-components-v2/RichTextEditor';
import { RichTextViewer } from '@vimily/bonjoro-ui-components-v2/RichTextViewer';

import SidebarProfile from '~/Share/components/SidebarProfile';
import type { UserSimple } from '~/types/models';
import { theme } from '@vimily/bonjoro-ui-components-v2';

const StyledSidebarProfile = styled(SidebarProfile)`
  border-bottom: 0;
  box-shadow: 0px 3px 6px #00000029;
  z-index: 99;
`;

export type SidebarProps = {
  user: UserSimple;
  instructions: RichText;
  className?: string;
  collapseAtWidthSize?: number;
  fontColor?: string;
  fontFamily?: string;
};

export default function Sidebar({
  user,
  instructions,
  className = '',
  collapseAtWidthSize = 1024,
  fontColor = theme.colors.neutral[900],
  fontFamily,
}: SidebarProps) {
  const [isInstructionPanelOpened, setIsInstructionPanelOpened] =
    useState(true);

  const isMobile = !useMedia({
    minWidth: collapseAtWidthSize,
  });

  useEffect(() => {
    setIsInstructionPanelOpened(!isMobile);
  }, [isMobile]);

  return (
    <div
      className={cx(
        'z-50 w-full lg:w-[422px] h-auto flex flex-col shadow-md bg-white relative',
        className
      )}
    >
      <StyledSidebarProfile
        {...user}
        avatar={user.image}
        className='h-14 md:h-16'
        showBackButton={isInstructionPanelOpened && isMobile}
        onBackClick={() => setIsInstructionPanelOpened(false)}
        onProfileImageClick={
          isMobile ? () => setIsInstructionPanelOpened(true) : undefined
        }
        fontColor={fontColor}
        fontFamily={fontFamily}
      />
      <div
        className={cx(
          'p-4 h-[calc(100vh-144px)] w-full absolute md:h-full md:static z-50 bg-white md:px-8',
          'border-neutral-300 border-0 border-b border-solid',
          'overflow-x-hidden overflow-y-auto top-[56px] md:top-[64px]',
          'scrollbar-thin scrollbar-track-neutral-200 scrollbar-track-rounded-full',
          'scrollbar-thumb-neutral-400 scrollbar-thumb-rounded-full',
          {
            hidden: !isInstructionPanelOpened,
          }
        )}
      >
        <div className='text-sm whitespace-pre-wrap break-words'>
          <RichTextViewer
            value={instructions}
            style={{ color: fontColor, fontFamily }}
          />
        </div>
      </div>
    </div>
  );
}
